<template>
    <div id="Wrapper"></div>
</template>
<script>

const kddi_fastio_uri = process.env.VUE_APP_TOP_PAGE_URL;

export default {
    name: 'Relogin',
    created: function(){
        let site_no = this.$store.getters['auth/getSiteNo']
        let relogin_uri = kddi_fastio_uri + "login/authorize?app_id=livenext_app&on_success_url=" + encodeURIComponent(site_no)
        location.href = relogin_uri
    }
}
</script>
<style lang="scss">
</style>
